import React from 'react';
import './style.css';
import LoginForm from './LoginForm';
import { useStore } from '../../store/Store';

export const Login = () => {
  const {
    state: { errorLogin }
  } = useStore();

  return (
    <div className="card Login__card">
      <div className="Login__title">
        <h2>Inicio de sesión</h2>
      </div>
      <div className="card-body">
        <LoginForm />
      </div>

      {errorLogin && (
        <div className="card-footer">
          <div className="Login__error">{errorLogin}</div>
        </div>
      )}
    </div>
  );
};
